import React from "react"
import "./out-of-the-box.scss"

const OutOfTheBox = (props) => {

    const { informationFilter } = props


    return (
        <div className="f-outOfTheBox__PreFooter">
            <div className="f-outOfTheBox__PreFooter-content">
                <div className="f-outOfTheBox__PreFooter-content__info">
                    <p>{informationFilter[0].informacionCuaternaria.json.content[0].content[0].value}</p>
                    <a href={informationFilter[0].ctaRedireccionCuaternario} target="_blank">{informationFilter[0].ctaNombreCuaternario}</a>
                </div>
                <div className="f-outOfTheBox__PreFooter-content__image">
                    <img src={informationFilter[0].imagenCuaternaria.file.url} alt={informationFilter[0].imagenCuaternaria.file.fileName} />
                </div>
            </div>
        </div>
    )
}

export default OutOfTheBox